import {
  Box,
  HStack,
  Image,
  Skeleton,
  Stack,
  StackProps,
  Tag,
  Text,
} from "@chakra-ui/react";
import { PriceReviewTag } from "./price-review-tag";
import { ProductReviewCardButton } from "./product-review-card-button";

export interface ProductReviewCardProps extends StackProps {
  name: string;
  priceRating: number;
  href: string;
  imageUrl: string;
  buttonLabel?: string;

  tag: {
    name: string;
    color: string;
  };
}

export const ProductReviewCard = ({
  name,
  href,
  imageUrl,
  priceRating,
  buttonLabel,
  children,
  tag,
  ...rest
}: ProductReviewCardProps) => {
  return (
    <Stack spacing="4" mx="auto" {...rest}>
      <Box position="relative" className="group">
        <Image
          className="product-review-card-image"
          src={imageUrl}
          style={{ objectFit: "contain" }}
          alt={name}
          draggable="false"
          fallback={<Skeleton />}
          borderRadius="md"
          maxH="2xs"
          w="full"
        />
        <HStack spacing="3" position="absolute" top="4" left="4">
          <Tag
            key={tag.name}
            bg={`${tag.color}.500`}
            color="white"
            fontWeight="semibold"
          >
            {tag.name}
          </Tag>
        </HStack>
        <Box
          opacity={0}
          transition="opacity 0.1s"
          position="absolute"
          className="container"
          bottom="3"
          left="3"
          right="3"
          _groupHover={{ opacity: 1 }}
        >
          <ProductReviewCardButton
            w="full"
            href={href}
            aria-label="View details"
            buttonLabel={buttonLabel}
          />
        </Box>
      </Box>
      <Stack spacing="1">
        <HStack justifyContent="space-between">
          <Text
            as="a"
            href={href}
            target="_blank"
            color="text"
            fontSize="sm"
            fontWeight="semibold"
            letterSpacing="wider"
            textTransform="uppercase"
          >
            {name}
          </Text>
          <PriceReviewTag defaultValue={priceRating} max={3} />
        </HStack>
        {children}
      </Stack>
    </Stack>
  );
};
